/* 3SQM — quick-add. One delegated listener for every [data-quick-add]
   button (front-grid cards today, anywhere tomorrow). Adds the button's
   variant via cart/add.js, fires `cart:added` (the cart-drawer listens
   for exactly that and opens itself), and flashes the button's
   data-added-label for 1.6s. JS-off: the wrapping form POSTs natively
   to /cart/add — this file just upgrades it. */
(() => {
  if (window.__sqmQuickAdd) return;
  window.__sqmQuickAdd = true;

  const rootPath = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-quick-add]');
    if (!btn) return;
    // capability check BEFORE preventDefault: without fetch or a drawer
    // to open, let the wrapping form POST natively to /cart/add
    if (!window.fetch || !document.querySelector('cart-drawer')) return;
    event.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;

    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('quick-add failed');
        return response.json();
      })
      .then(() => {
        window.dispatchEvent(new Event('cart:added'));
        const restingLabel = btn.textContent;
        btn.textContent = btn.dataset.addedLabel || restingLabel;
        setTimeout(() => {
          btn.textContent = restingLabel;
          btn.disabled = false;
        }, 1600);
      })
      .catch(() => {
        // sold-out race / network blip: fall back to the native form so
        // the user lands on Shopify's own error instead of a dead click
        btn.disabled = false;
        if (btn.form) btn.form.submit();
      });
  });
})();
